/**
 * Global design tokens for Skill to Japan BD.
 * Japan flag colours (red) + Bangladesh flag (green) combined palette.
 */
const THEME = {
  red:       '#BC002D',   // Japan red
  redDark:   '#8B0020',
  redLight:  '#F9E5EA',
  green:     '#006A4E',   // Bangladesh green
  greenLight:'#E5F3EF',
  navy:      '#0D1B2A',   // deep dark
  ivory:     '#FFF8F4',   // warm off-white page background
  sand:      '#F5EFE8',   // section alternate background
  gold:      '#C9A84C',
  white:     '#FFFFFF',
};

export default THEME;
